import { useDarkMode } from "@/hooks/useDarkMode";
import React from "react";
import { BsCheck } from "react-icons/bs";

interface CheckmarkProps {
  disabled: boolean;
}

function Checkmark(props: CheckmarkProps) {
  const { disabled } = props;
  const isDark = useDarkMode();
  return (
    <div
      className={`rounded-full ${
        disabled
          ? "bg-transparent dark:bg-primary-900 border-[#CBC9F2] dark:border-[#CBC9F2]"
          : "bg-success-200 dark:bg-[#352FC3] border-primary-500 dark:border-[#A7F3D0]"
      } w-5 h-5 flex justify-center items-center border `}
    >
      <BsCheck
        size={18}
        color={
          isDark
            ? disabled
              ? "#CBC9F2"
              : "#A7F3D0"
            : disabled
              ? "#CBC9F2"
              : "#352FC3"
        }
      />
    </div>
  );
}

export default Checkmark;
